/**
 * Single message view
 */

import { connect } from "react-redux";
import React from "react";
import { RouteProps, RouteComponentProps } from "react-router";

import { Grid } from "material-ui";

import ChatWrapper from "./components/ChatWrapper";

import { ReduxState, ReduxDispatch } from "../../../ducks/reducers";
import { IChatMessage, IHandler } from "../../../util/interfaces";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import { ShowBottomBar, SetBottomBarTab } from "ducks/common";
import { MessagesTab } from "components/BottomBar/BottomBar";
import {
    getThreadById,
    messagesLoading,
    getMessageThreads,
    sendMessage,
    setMessagesRead,
} from "../../../ducks/messages";
import {
    MessageStatus,
    MessageThreadStatus,
    CreateMessageDto,
    MessageSender,
} from "../../../util/DTOs/MessageDtos";
import { deepEqual } from "../../../util/utils";

/**
 * Props provided by redux
 */
interface IThreadPageProps extends RouteComponentProps<{ threadId: number }> {}

/**
 * Dispatch functions provided by redux
 */
interface IThreadPageDispatchProps {
    sendMessage: (threadId: number, body: string) => void;
    fetchThreads: () => void;
    setMessageRead: (messageId: number[]) => void;
    showBottomBar: (show: boolean) => void;
    setBottomBarTab: (tab?: number) => void;
}

/**
 * Internal state of this component
 */
interface IThreadPageState {
    windowWidth: number;
    windowHeight: number;
}

interface IThreadPageReduxProps {
    handler: { name?: string; img?: string };
    messages: IChatMessage[];
    loading: boolean;
    readOnlyThread: boolean;
}

/**
 * Combined properties of he component
 */
type ThreadPageProps = IThreadPageProps &
    IThreadPageDispatchProps &
    IThreadPageReduxProps &
    RouteProps;

class ThreadPage extends React.Component<ThreadPageProps, IThreadPageState> {
    componentWillMount() {}

    componentDidMount() {
        // Force scroll to bottom to the newest message
        window.scrollTo(0, document.body.scrollHeight);
        this.props.fetchThreads();
        this.props.showBottomBar(false);
        this.props.setBottomBarTab(MessagesTab);
        window.addEventListener("resize", this.windowResize);

        const unreadMessagesIds = this.props.messages
            .filter((msg) => !msg.isRead && !msg.own)
            .map((it) => it.id);
        if (unreadMessagesIds.length !== 0) {
            this.props.setMessageRead(unreadMessagesIds);
        }
    }

    componentWillReceiveProps(nextProps: ThreadPageProps) {
        window.scrollTo(0, document.body.scrollHeight);

        if (!deepEqual(this.props.messages, nextProps.messages)) {
            const unreadMessagesIds = nextProps.messages
                .filter((msg) => !msg.isRead && !msg.own)
                .map((it) => it.id);
            if (unreadMessagesIds.length !== 0) {
                this.props.setMessageRead(unreadMessagesIds);
            }
        }
    }

    componentWillUnmount() {
        this.props.showBottomBar(true);
        this.props.setBottomBarTab();
        window.removeEventListener("resize", this.windowResize);
    }

    windowResize = () => {
        this.setState((prevState) => ({
            ...prevState,
            windowWidth: this.calculateWindowWidth(),
            windowHeight: this.calculateWindowHeight(),
        }));
    };

    calculateWindowWidth() {
        return window.innerWidth;
    }

    calculateWindowHeight() {
        return window.innerHeight;
    }

    render() {
        const handler = {
            name: this.props.handler.name,
            avatarUrl: this.props.handler.img,
        } as IHandler;

        const showSpinner =
            (!this.props.messages || this.props.messages.length === 0) &&
            this.props.loading;

        return (
            <div className="ReactTemplate__ThreadPage">
                <FullPageSpinner loading={showSpinner} />
                <div>
                    <Grid
                        container
                        justify="center"
                        alignItems={"center"}
                        spacing={0}
                    >
                        <Grid item xs={12} md={8}>
                            <ChatWrapper
                                messages={this.props.messages}
                                handler={handler}
                                threadId={this.props.match.params.threadId}
                                readOnlyThread={this.props.readOnlyThread}
                            />
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: ThreadPageProps
): IThreadPageReduxProps => {
    const thread = getThreadById(state, props.match.params.threadId);
    const loading = messagesLoading(state);
    let messages =
        thread && thread.messages
            ? thread.messages.map((msg) => {
                  return {
                      message: msg.content,
                      date: msg.createdAt,
                      own: msg.sender === MessageSender.Customer,
                      id: msg.id,
                      isRead:
                          msg.status === MessageStatus.Read &&
                          msg.sender !== MessageSender.Customer,
                      attachments: msg.attachments,
                  } as IChatMessage;
              })
            : [];
    return {
        messages: messages,
        loading: loading,
        readOnlyThread:
            thread && thread.status === MessageThreadStatus.Archived,
        handler: {
            name: thread && "HYPO", // TODO Who the messagethread has been delegated to
            img: thread && "", // TODO Who the messagethread has been delegated to
        },
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IThreadPageDispatchProps => {
    return {
        sendMessage: (threadId: number, body: string) => {
            dispatch(
                sendMessage({
                    messageThreadId: threadId,
                    content: body,
                    status: MessageStatus.New,
                    sender: MessageSender.Customer,
                } as CreateMessageDto)
            );
        },
        fetchThreads: () => {
            dispatch(getMessageThreads());
        },
        setMessageRead: (messageIds: number[]) => {
            dispatch(setMessagesRead(messageIds));
        },
        showBottomBar: (show: boolean) => {
            dispatch(ShowBottomBar(show));
        },
        setBottomBarTab: (tab?: number) => {
            dispatch(SetBottomBarTab(tab));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThreadPage as any);



// WEBPACK FOOTER //
// ./src/views/messages/threadpage/ThreadPage.tsx